import React from 'react'

// import Icon from './Icon'

function ProgressBar({
  title,
  percent, 
  label,
  icon,
  middle,
  dashboard,
  // character
}) {
  
  return (
    <div className={`mc-progressBar-container ${title ? 'has-title' : ''} ${middle ? 'col-2' : 'col-1'}`}>
      {title &&
        <div className='mc-progressBar-title'>
          {title}
        </div>
      }
      {dashboard &&
        <span className='mc-progressBar-label'>{`${percent}%`} {dashboard}</span>
      }
      <div className={(percent) === 100 ? "mc-progressBar-progress progress_100" : "mc-progressBar-progress"} style={{"width": `${(percent) > 100 ? (100) : (percent)}%`}}></div>
      <div className={`mc-progressBar-percent`}>
        {icon &&
          <img src={icon} />
        }
        
        {label && label}
      </div>
    </div>
  )
}

export default ProgressBar